module.exports = (theme) => ({
  /** @deprecated Do not use `ds-icon`. It has been deprecated, just use the icon name for example `ds-icon-thermometer`. */
  ".icon::before": {
    fontFamily: theme("fontFamily.icons"),
    fontSize: theme("fontSize.3xl"),
    height: theme("lineHeight.base"),
    width: theme("lineHeight.base"),
    lineHeight: theme("lineHeight.base"),
    verticalAlign: "bottom",
    fontWeight: "normal",
  },
  ".icon.icon-thermometer::before": {
    content: '"\\EA4C"',
  },
  ".icon.icon-chat::before": {
    content: '"\\E9D0"',
  },
  ".icon.icon-send::before": {
    content: '"\\EA87"',
  },
  ".icon.icon-meter::before": {
    content: '"\\e9c3"',
  },
  ".icon.icon-pen::before": {
    content: '"\\ea71"',
  },
  ".icon.icon-bulb-1::before": {
    content: '"\\e940"',
  },
  ".icon.icon-bulb-2::before": {
    content: '"\\e941"',
  },
  ".icon.icon-bulb-3::before": {
    content: '"\\e942"',
  },
  ".icon.icon-bulb-4::before": {
    content: '"\\e943"',
  },
  ".icon.icon-bulb-5::before": {
    content: '"\\e944"',
  },
  ".icon.icon-search::before": {
    content: '"\\e98b"',
  },
  ".icon.icon-off::before": {
    content: '"\\ea7d"',
  },
  ".icon.icon-menu::before": {
    content: '"\\e986"',
  },
  ".icon.icon-checkmark::before": {
    content: '"\\e97f"',
  },
  ".icon.icon-change::before": {
    content: '"\\e9c7"',
  },
  ".icon.icon-cross::before": {
    content: '"\\e980"',
  },
  ".icon.icon-minus::before": {
    content: '"\\e984"',
  },
  ".icon.icon-plus::before": {
    content: '"\\e987"',
  },
  ".icon.icon-up::before": {
    content: '"\\e98c"',
  },
  ".icon.icon-right::before": {
    content: '"\\e989"',
  },
  ".icon.icon-bottom::before": {
    content: '"\\e981"',
  },
  ".icon.icon-left::before": {
    content: '"\\e983"',
  },
  ".icon.icon-arrow-bottom-right::before": {
    content: '"\\ea60"',
  },
  ".icon.icon-arrow-bottom-left::before": {
    content: '"\\ea61"',
  },
  ".icon.icon-arrow-bottom::before": {
    content: '"\\ea62"',
  },
  ".icon.icon-arrow-left::before": {
    content: '"\\ea63"',
  },
  ".icon.icon-arrow-right::before": {
    content: '"\\ea64"',
  },
  ".icon.icon-arrow-top-left::before": {
    content: '"\\ea65"',
  },
  ".icon.icon-arrow-top-right::before": {
    content: '"\\ea66"',
  },
  ".icon.icon-arrow-top::before": {
    content: '"\\ea67"',
  },
  ".icon.icon-user::before": {
    content: '"\\ea92"',
  },
  ".icon.icon-house::before": {
    content: '"\\e982"',
  },
  ".icon.icon-apartment::before": {
    content: '"\\ea0d"',
  },
  ".icon.icon-industry::before": {
    content: '"\\e9fa"',
  },
  ".icon.icon-farm::before": {
    content: '"\\e9e5"',
  },
  ".icon.icon-moving::before": {
    content: '"\\e9ce"',
  },
  ".icon.icon-call::before": {
    content: '"\\ea6a"',
  },
  ".icon.icon-thumbsup::before": {
    content: '"\\ea4f"',
  },
  ".icon.icon-thumbsdown::before": {
    content: '"\\ea4e"',
  },
  ".icon.icon-info::before": {
    content: '"\\ea78"',
  },
  ".icon.icon-globe::before": {
    content: '"\\e9eb"',
  },
  ".icon.icon-facebook::before": {
    content: '"\\e918"',
  },
  ".icon.icon-flickr::before": {
    content: '"\\e919"',
  },
  ".icon.icon-instagram::before": {
    content: '"\\e91A"',
  },
  ".icon.icon-linkedin::before": {
    content: '"\\e91B"',
  },
  ".icon.icon-slideshare::before": {
    content: '"\\e91E"',
  },
  ".icon.icon-twitter::before": {
    content: '"\\e920"',
  },
  ".icon.icon-youtube::before": {
    content: '"\\e924"',
  },
  ".icon.icon-download::before": {
    content: '"\\ea70"',
  },
  ".icon.icon-calendar-1::before": {
    content: '"\\E960"',
  },
  ".icon.icon-calendar-2::before": {
    content: '"\\E961"',
  },
  ".icon.icon-calendar-3::before": {
    content: '"\\E962"',
  },
  ".icon.icon-calendar-4::before": {
    content: '"\\E963"',
  },
  ".icon.icon-calendar-5::before": {
    content: '"\\E964"',
  },
  ".icon.icon-calendar-6::before": {
    content: '"\\E965"',
  },
  ".icon.icon-calendar-7::before": {
    content: '"\\E966"',
  },
  ".icon.icon-calendar-8::before": {
    content: '"\\E967"',
  },
  ".icon.icon-calendar-9::before": {
    content: '"\\E968"',
  },
  ".icon.icon-calendar-10::before": {
    content: '"\\E969"',
  },
  ".icon.icon-calendar-11::before": {
    content: '"\\E96A"',
  },
  ".icon.icon-calendar-12::before": {
    content: '"\\E96B"',
  },
  ".icon.icon-calendar-13::before": {
    content: '"\\E96C"',
  },
  ".icon.icon-calendar-14::before": {
    content: '"\\E96D"',
  },
  ".icon.icon-calendar-15::before": {
    content: '"\\E96E"',
  },
  ".icon.icon-calendar-16::before": {
    content: '"\\E96F"',
  },
  ".icon.icon-calendar-17::before": {
    content: '"\\E970"',
  },
  ".icon.icon-calendar-18::before": {
    content: '"\\E971"',
  },
  ".icon.icon-calendar-19::before": {
    content: '"\\E972"',
  },
  ".icon.icon-calendar-20::before": {
    content: '"\\E973"',
  },
  ".icon.icon-calendar-21::before": {
    content: '"\\E974"',
  },
  ".icon.icon-calendar-22::before": {
    content: '"\\E975"',
  },
  ".icon.icon-calendar-23::before": {
    content: '"\\E976"',
  },
  ".icon.icon-calendar-24::before": {
    content: '"\\E977"',
  },
  ".icon.icon-calendar-25::before": {
    content: '"\\E978"',
  },
  ".icon.icon-calendar-26::before": {
    content: '"\\E979"',
  },
  ".icon.icon-calendar-27::before": {
    content: '"\\E97A"',
  },
  ".icon.icon-calendar-28::before": {
    content: '"\\E97B"',
  },
  ".icon.icon-calendar-29::before": {
    content: '"\\E97C"',
  },
  ".icon.icon-calendar-30::before": {
    content: '"\\E97D"',
  },
  ".icon.icon-calendar-31::before": {
    content: '"\\E97E"',
  },
  ".icon.icon-agent::before": {
    content: '"\\E9B5"',
  },
  ".icon.icon-open-connection::before": {
    content: '"\\E985"',
  },
  ".icon.icon-close-connection::before": {
    content: '"\\EA7D"',
  },
});
